import React, { memo } from 'react';
import { getRatingColor } from '../utils/helpers';
import { getGoalieAssignmentLabel } from '../utils/assignments';
import PlayerNameBadges from './PlayerNameBadges';

function GoalieCard({
  goalie,
  goalieRateColumns,
  rateMin,
  rateMax,
  assignment,
  onPlayerClick,
  onAddToLineup,
}) {
  const assigned = Boolean(assignment);

  return (
    <div
      className={`player-card ${assigned ? 'assigned' : ''}`}
      onClick={(e) => onPlayerClick(e, goalie)}
    >
      <div className="player-card-header">
        <div className="player-info">
          <div className="player-name-row">
            <span className="player-name-text">{goalie.name}</span>
            <PlayerNameBadges player={goalie} size="large" showPlayerType={false} />
            <button
              type="button"
              className="wishlist-btn lineup-btn"
              onClick={(e) => {
                e.stopPropagation();
                onAddToLineup(goalie, e);
              }}
            >
              + Lineup
            </button>
          </div>
          <div className="player-age">{goalie.age ? `Age: ${goalie.age}` : '\u00A0'}</div>
          <div className="player-meta-line">
            <span>G</span>
            <span className="player-meta-sep">·</span>
            <span>{goalie.team === 'N/A' ? 'FA' : goalie.team}</span>
          </div>
          <div className="player-salary">
            ${goalie.salary ? Number(goalie.salary).toLocaleString('en-US') : '0'}
          </div>
        </div>
        <div className="player-status">
          {assigned ? (
            <div className="assigned-badge" title={getGoalieAssignmentLabel(assignment)}>
              G{assignment ? assignment.replace('goalie', '') : '1'}
            </div>
          ) : (
            <div className="unassigned-badge" title="Click to assign">
              •
            </div>
          )}
        </div>
      </div>

      <div className="player-ratings">
        {goalieRateColumns.map((col) => {
          const value = goalie[col.name] || 0;
          const backgroundColor = getRatingColor(value, rateMin, rateMax);
          return (
            <div
              key={col.name}
              className="rating-item"
              data-rating={col.name}
              style={{ backgroundColor, borderColor: backgroundColor }}
            >
              <span className="rating-label">{col.name}</span>
              <span className="rating-value">{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(GoalieCard);
